export * from './apiResponse.interface';
export * from './slideGenerator.interface';
